

export function GalleryWHEEL(){
  return {
    "images": [
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_001.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_002.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_003.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_004.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_005.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_006.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_007.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_008.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_009.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_010.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryWHEEL/IMG_011.jpg"}
    ]
  }
}
